import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errorMessage } from "@/lib/api";

const reasons = ["Ne radi se u praksi", "Nije potrebno za ovaj slučaj", "Napravljeno izvan aplikacije"];

export function CaseStepActions({ processId, stepId, skipped, onSaved }: {
  processId: string; stepId: string; skipped: boolean; onSaved: () => void;
}) {
  const [choosing, setChoosing] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function save(reason?: string) {
    if (busy) return;
    setBusy(true); setError("");
    try {
      await api.post(`/dozvole/predmeti/${processId}/steps/${stepId}/${reason ? "skip" : "restore"}`, reason ? { reason, ...(note.trim() ? { note: note.trim() } : {}) } : {});
      setChoosing(false); setNote(""); onSaved();
    } catch (cause) { setError(errorMessage(cause, "Korak nije spremljen.")); }
    finally { setBusy(false); }
  }
  return <div className="mt-2 space-y-2">
    {skipped ? <Button variant="secondary" disabled={busy} onClick={() => void save()}>Vrati korak</Button>
      : <Button variant="secondary" disabled={busy} onClick={() => setChoosing(value => !value)}>Ne radi se</Button>}
    {choosing && <div role="group" aria-label="Razlog za Ne radi se" className="space-y-2 rounded border p-3">
      <label className="block">Napomena (neobavezno)<Input value={note} maxLength={2000} disabled={busy} onChange={event => setNote(event.target.value)} /></label>
      <p>Odaberite razlog za spremanje:</p>
      <div className="flex flex-wrap gap-2">{reasons.map(reason => <Button key={reason} variant="secondary" disabled={busy} onClick={() => void save(reason)}>{reason}</Button>)}</div>
    </div>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
